








































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import UserModule from '@/store/modules/user';
import moment from 'moment';

@Component({})
export default class SchedulerInfo extends Vue {
  @PropSync('eventCount', {}) eventCountSync!: any;

  public get currentUserRole() {
    return UserModule.currentRole;
  }

  public get averageResponseTime() {
    const duration = parseFloat(this.eventCountSync.averageResponseTime)
      .toFixed(2);

    let timeDuration = '';
    const parsedDuration = parseFloat(duration);
    const days = Math.floor(parsedDuration / (3600 * 24));
    const hours = Math.floor(parsedDuration % ((3600 * 24) / 3600));
    const minutes = Math.floor((parsedDuration % 3600) / 60);
    if (minutes < 60 && hours < 24 && days < 1) {
      timeDuration = `${minutes} Minutes`;
    } else if (minutes < 60 && hours <= 24 && days < 1) {
      if (hours > 1) {
        timeDuration = `${hours} Hours`;
      } else {
        timeDuration = `${duration} Hour`;
      }
    } else if (minutes < 60 && hours < 24 && days >= 1) {
      if (days > 1) {
        timeDuration = `${days} Days`;
      } else {
        timeDuration = `${days} Day`;
      }
    }
    return timeDuration;
  }
}
